module.exports = __webpack_public_path__ + "img/banner_body-link-base.79e8f8be.svg";